import { useCallback, useState } from "react";
import { Psychologist } from "../../../models/Psychologist";
import PsychologistRepository from "../../../repositories/PsychologistRepository";

export const useGetPsychologists = () => {
  const [data, setData] = useState<Psychologist[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [totalData, setTotalData] = useState<number>(0);

  const loadData = useCallback(async (params = {}) => {
    setIsLoading(true);

    return new Promise(async (resolve, reject) => {
      try {
        const response = await PsychologistRepository.findAll({
          ...params,
          with: ["photo"],
        });

        const { data: responseData, meta } = response.data;
        setData(responseData);
        setTotalData(meta.total);
        resolve(responseData);
      } catch (error) {
        reject(error);
      } finally {
        setIsLoading(false);
      }
    });
  }, []);

  return {
    data,
    isLoading,
    loadData,
    totalData,
  };
};
